import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';
import { NumberParam, useQueryParam } from 'use-query-params';

import { ShareUserType } from '../models';

export function useSharedUsers(setSelectEmployees: React.Dispatch<React.SetStateAction<ShareUserType[]>>) {
  const [dashboardId] = useQueryParam('dashboardId', NumberParam);
  const visible = useAppSelector(state => state.dashboardReducer.visibleShareDashboard);

  const { data, ...arg } = useQuery<{ sharedUsers: ShareUserType[] }>(
    ['dashboard-v2-shared-users', dashboardId],
    async () => {
      const { data } = await $api.get(`/v1/dashboard/shared-users/${dashboardId}`);

      return { sharedUsers: data?.data };
    },
    {
      enabled: !!dashboardId && visible,
      onSuccess: ({ sharedUsers }) => {
        setSelectEmployees(sharedUsers);
      }
    }
  );

  return { ...data, ...arg };
}
